<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
        >新增
        </el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="list">
      <el-table-column label="chanCode" align="center" prop="id" width="250">
      </el-table-column>

      <el-table-column label="secret" align="center" prop="secret" width="400">
      </el-table-column>
      <el-table-column label="应用名称" align="center" prop="appName" width="300">
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status" width="100">
        <template slot-scope="scope">
          <el-tag
              type="success"
              v-if="scope.row.status === 1"
              effect="dark">
            启用
          </el-tag>
          <el-tag
              type="danger"
              v-else
              effect="dark">
            禁用
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" width="200">

      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
          >修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改应用对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="应用名称" prop="appName">
              <el-input v-model="form.appName" placeholder="应用名称"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="回调地址" prop="hookUrl">
              <el-input v-model="form.hookUrl" placeholder="回调地址"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="默认店员电话" prop="defaultUser">
              <el-input v-model="form.defaultUser" placeholder="默认店员电话"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="form.remark">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      open: false,
      loading: false,
      merchantLoading: false,
      list: [],
      merchantIdList: [],
      editMerchantList: [],
      title: "",
      // 表单参数
      form: {
        id: undefined,
        secret: undefined,
        appName: undefined,
        defaultUser: undefined,
        status: 1,
        hookUrl: undefined,
        remark: ""
      },
      // 表单校验
      rules: {
        appName: [
          {required: true, message: "应用名称不能为空", trigger: "blur"}
        ],
        hookUrl: [
          {required: true, message: "回调地址不能为空", trigger: "blur"}
        ],
        defaultUser: [
          {
            required: true, message: "默认店员不能为空", trigger: "blur"
          }
        ]

      }
    }
  },
  methods: {
    /** 查询应用列表 */
    getList() {
      this.loading = true;
      let self = this;
      this.$api.listOpenApp().then(
          response => {
            self.list = response.data;
            this.loading = false;
          }
      );
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加开放应用";
    },

    handleUpdate(row) {
      let self = this;
      this.open = true;
      this.title = "更新开放应用";
      let param = {
        id: row.id
      }
      this.$api.getOpenApp(param).then(response => {
        self.form.id = response.data.id;
        self.form.appName = response.data.appName;
        self.form.remark = response.data.remark;
        self.form.secret = response.data.secret;
        self.form.defaultUser = response.data.defaultUser;
        self.form.hookUrl = response.data.hookUrl;
        self.form.status = response.data.status;
      });
    },

    /** 表单重置 */
    reset() {
      this.form = {
        id: undefined,
        secret: undefined,
        appName: undefined,
        status: 1,
        defaultUser: undefined,
        hookUrl: undefined,
        remark: ""
      };
      this.resetForm("form");
    },

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },

    /** 提交按钮 */
    submitForm: function () {

      let self = this;
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (self.form.id != undefined) {
            self.$api.updateOpenApp(self.form).then(
                response => {
                  if (response.code === 200) {
                    self.$message({
                      message: '更新成功',
                      type: 'success'
                    });
                  } else {
                    self.$message({
                      message: '更新失败',
                      type: 'error'
                    });
                  }
                  self.open = false;
                  self.getList();
                }
            );
          } else {

            self.$api.createOpenApp(self.form).then(
                response => {
                  if (response.code === 200) {
                    self.$message({
                      message: '创建成功',
                      type: 'success'
                    });
                  } else {
                    self.$message({
                      message: '创建失败',
                      type: 'error'
                    });
                  }
                  self.open = false;
                  self.getList();
                }
            );
          }
        }
      });
    },
  },
  created() {
    this.getList();

  },
}
</script>

<style scoped>

</style>
